import { postRequest, getRequest } from '@bo-apis/axios';

const exhibitionUrl = 'api/v1/exhibition';

const createExhibition = (exhibition) =>
  postRequest({
    url: `${exhibitionUrl}/create-exhibition`,
    data: { ...exhibition },
  });

const createIntegrationExhibition = (exhibition) =>
  postRequest({
    url: `${exhibitionUrl}/create-integration-exhibition`,
    data: { ...exhibition },
  });

const createAllianceExhibition = (exhibition) =>
postRequest({
  url: `${exhibitionUrl}/create-alliance-exhibition`,
  data: { ...exhibition },
});  

const getExhibitionList = (pageable, search) => {
  if (pageable) {
    return postRequest({
      url: `${exhibitionUrl}/page`,
      params: { ...pageable },
      data: { ...search },
    });
  }
  return postRequest({
    url: `${exhibitionUrl}/list`,
    data: { ...search },
  });
};

const getExhibitionStateCount = (search) => {
  return postRequest({
    url: `${exhibitionUrl}/state-count`,
    data: { ...search },
  });
};

const getExhibition = (exhibitionNo, isCopy) => {
  if (isCopy) {
    return getRequest({ url: `${exhibitionUrl}/copy/${exhibitionNo}` });
  }
  return getRequest({ url: `${exhibitionUrl}/${exhibitionNo}` });
};

const getAllianceExhibition = (exhibitionNo, isCopy) => {
  if (isCopy) {
    return getRequest({ url: `${exhibitionUrl}/alliance/copy/${exhibitionNo}` });
  }
  return getRequest({ url: `${exhibitionUrl}/alliance/${exhibitionNo}` });
};

const getRelatedExhibitionList = (exhibitionNo) => getRequest({ url: `${exhibitionUrl}/integration/${exhibitionNo}` });

const getGoodGroupGoodList = (goodGroupNo) => getRequest({ url: `${exhibitionUrl}/${goodGroupNo}/good-list` });

const updateExhibitionStatus = (targetStatus, statusCode, exhibitionIdList) =>
  postRequest({
    url: `/api/v1/exhibition/status`,
    data: { targetStatus, statusCode, exhibitionIdList },
  });

const temporarySaveExhibition = (exhibition) => {
  return postRequest({
    url: `${exhibitionUrl}/temporary-save-exhibition`,
    data: { ...exhibition },
  });
};

const temporarySaveIntegrationExhibition = (exhibition) => {
  return postRequest({
    url: `${exhibitionUrl}/temporary-save-integration-exhibition`,
    data: { ...exhibition },
  });
};

const updateExhibition = (exhibition) => {
  return postRequest({
    url: `${exhibitionUrl}/update-exhibition`,
    data: { ...exhibition },
  });
};

const updateIntegrationExhibition = (exhibition) => {
  return postRequest({
    url: `${exhibitionUrl}/update-integration-exhibition`,
    data: { ...exhibition },
  });
};

const updateAllianceExhibition = (exhibition) => {
  return postRequest({
    url: `${exhibitionUrl}/update-alliance-exhibition`,
    data: { ...exhibition },
  });
};

export default {
  createExhibition,
  createIntegrationExhibition,
  createAllianceExhibition,
  getExhibitionList,
  getExhibitionStateCount,
  getExhibition,
  getAllianceExhibition,
  getRelatedExhibitionList,
  getGoodGroupGoodList,
  updateExhibitionStatus,
  temporarySaveExhibition,
  temporarySaveIntegrationExhibition,
  updateExhibition,
  updateIntegrationExhibition,
  updateAllianceExhibition,
};
